import { useIsViewingEnterpriseOrg } from 'features/organization/hooks/useIsViewingEnterpriseOrg';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { CommitmentsViewMode } from '../_types';
import { useIsEnterpriseCommitmentsEnabled } from '../hooks';

export const useCommitmentsViewMode = (): CommitmentsViewMode => {
  const isViewingEnterpriseOrg = useIsViewingEnterpriseOrg();
  const { enterpriseOrgId } = useOrganizations();

  const isEnterpriseCommitmentsEnabled = useIsEnterpriseCommitmentsEnabled();

  if (!isEnterpriseCommitmentsEnabled) {
    return { type: 'standard' };
  }

  if (isViewingEnterpriseOrg && enterpriseOrgId) {
    return { type: 'enterprise', enterpriseOrgId };
  }

  return { type: 'child-org' };
};
